import { MapPin, Phone, Clock } from "lucide-react";
import { usePublicLang } from "@/contexts/PublicLangContext";
import ScrollReveal from "./ScrollReveal";
import { LANDING } from "@/constants/testIds";

export default function VisitSection({ clinic, landing }) {
  const { t } = usePublicLang();
  if (!clinic.address && !clinic.phone && !landing.business_hours) return null;

  const mapSrc = clinic.address
    ? `https://maps.google.com/maps?q=${encodeURIComponent(clinic.address)}&z=14&output=embed`
    : null;

  return (
    <section id="contacto" className="py-20 md:py-28 px-5" data-testid={LANDING.visitSection}>
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10 md:gap-16 items-center">
        <ScrollReveal className="flex flex-col gap-6">
          <h2 className="font-serif text-3xl md:text-5xl tracking-tight text-[#292522]">{t("landing.visit.sectionTitle")}</h2>
          <div className="flex flex-col gap-4 text-[#6B6058]">
            {clinic.address && (
              <p className="flex items-start gap-3 text-base">
                <MapPin className="w-5 h-5 shrink-0 mt-0.5 text-[var(--brand-primary)]" />
                {clinic.address}
              </p>
            )}
            {clinic.phone && (
              <p className="flex items-start gap-3 text-base">
                <Phone className="w-5 h-5 shrink-0 mt-0.5 text-[var(--brand-primary)]" />
                {clinic.phone}
              </p>
            )}
            {landing.business_hours && (
              <p className="flex items-start gap-3 text-base whitespace-pre-line">
                <Clock className="w-5 h-5 shrink-0 mt-0.5 text-[var(--brand-primary)]" />
                <span>
                  <span className="block text-xs uppercase tracking-wide font-medium mb-1">{t("landing.visit.hoursLabel")}</span>
                  {landing.business_hours}
                </span>
              </p>
            )}
          </div>
        </ScrollReveal>
        {mapSrc && (
          <ScrollReveal delay={0.15}>
            <div className="rounded-2xl overflow-hidden aspect-[4/3]" data-testid={LANDING.visitMap}>
              <iframe title="map" src={mapSrc} className="w-full h-full border-0" loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
            </div>
          </ScrollReveal>
        )}
      </div>
    </section>
  );
}
